import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    alert:{
        top: "45%",
        "&>.MuiSnackbar-anchorOriginBottomCenter" :{
            left: "50%",
            right: "auto",
            bottom: 24,
            transform: "translateX(-50%)",
            top: "-4%",
        }
    }
}));

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function AlertaDeRespuesta(props) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Snackbar className={classes.alert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={props.open} autoHideDuration={3000} onClose={props.handClose}>
                <Alert variant="filled" severity={props.type}>{props.content}</Alert>
            </Snackbar>
        </div>
    );
}

